import { CustomerMembershipSchema } from "./wowpress/index.js";
import { z } from "zod";
const ReplySettingsSchema = z.object({
  enabled: z.boolean()
});
const SummarySettingsSchema = z.object({
  enabled: z.boolean()
});
const TagSettingsSchema = z.object({
  enabled: z.boolean(),
  maxTags: z.number().min(1).max(100)
});
const AgentAssignmentSchema = z.object({
  enabled: z.boolean(),
  method: z.enum(["priorityRandom", "priorityManual", "random"]),
  priorityTiers: z.array(CustomerMembershipSchema),
  priorityAgents: z.array(z.string())
});
const AISettingsSchema = z.object({
  summary: SummarySettingsSchema,
  tag: TagSettingsSchema,
  agentAssignment: AgentAssignmentSchema,
  reply: ReplySettingsSchema,
  chatbot: z.object({
    avatarUrl: z.string(),
    name: z.string(),
    description: z.string()
  })
});
export {
  AISettingsSchema,
  AgentAssignmentSchema,
  ReplySettingsSchema,
  SummarySettingsSchema,
  TagSettingsSchema
};
//# sourceMappingURL=settings.js.map